import { Box, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useQuery } from '@tanstack/react-query'
import InError from 'components/error'
import Loading from 'components/loading'
import WrapperWithHeader from 'components/wrapper-with-header'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import { useParams } from 'react-router-dom'
import { loadItem } from 'services/requests'
import TablePreview from '../table-preview'
import TablePreviewStreamlit from '../table-preview-streamlit'
interface IRouteWithTableParams {
  id: string
  snowflakeTableId: string
  organizationId: string
}

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
  },
}))

const TablePreviewHandler = () => {
  const { VITE_APP_AMBIENT } = import.meta.env
  const { snowflakeTableId, id, organizationId } = useParams<IRouteWithTableParams>()

  const classes = useStyles()

  const isProductionEnviroment = VITE_APP_AMBIENT === 'prod' || VITE_APP_AMBIENT === 'production'

  const tableContent = useQuery({
    queryKey: ['project', 'table', 'data', id],
    queryFn: () => loadItem('/projects', id ?? ''),
    enabled: id != null,
  })

  if (tableContent.isLoading) {
    return (
      <WrapperWithHeader>
        <Box className={classes.root}>
          <Loading />
        </Box>
      </WrapperWithHeader>
    )
  }

  if (tableContent.isError) {
    return (
      <WrapperWithHeader>
        <InError message='Error ao Carregar o Projeto' />
      </WrapperWithHeader>
    )
  }

  const project = tableContent.data.data.data as IProjectDTO

  if (isProductionEnviroment) {
    return (
      <TablePreview
        organizationId={organizationId}
        project={project}
        projectId={id}
        snowflakeTableId={snowflakeTableId}
      />
    )
  }

  return (
    <TablePreviewStreamlit
      organizationId={organizationId}
      project={project}
      projectId={id}
      snowflakeTableId={snowflakeTableId}
    />
  )
}

export default TablePreviewHandler
